export function defined(properties) {
    const definedProps = {};
    Object.keys(properties).map((key) => {
        if (properties[key] !== undefined) {
            definedProps[key] = properties[key];
        }
    });
    return definedProps;
}
